// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marker-popup_root__EclFK .mapboxgl-popup-content {
  padding: 0;
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/map/marker-popup/marker-popup.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".root :global .mapboxgl-popup-content {\n  padding: 0;\n  border-radius: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `marker-popup_root__EclFK`
};
export default ___CSS_LOADER_EXPORT___;
